// TODO: Replace these with design-system tokens once an amber palette is added to @b-stock/fe-core.
// All values are Tailwind amber/gray equivalents used by the listing-notes feature.
export const NOTES_AMBER_BG = '#FEF3C7' // amber-100 — header background, note button background
export const NOTES_AMBER_BORDER = '#FDE68A' // amber-200 — header border-bottom, badge background
export const NOTES_AMBER_TEXT_DARK = '#92400E' // amber-800 — "Show more" button text
export const NOTES_AMBER_ICON = '#D97706' // amber-600 — note icon color when note exists
export const NOTES_INPUT_BORDER = '#D1D5DB' // gray-300 — textarea border (no semantic token)
